export const WEB_API_KEY = '2ce3f515a02e816b2240e4f1';
